import { HTMLCustomElement } from '~/html-custom-element';
import { computePosition, shift, arrow, offset, autoUpdate, size } from 'floating-ui';
import { classes, on } from '~/helpers';

export class TooltipContainer extends HTMLCustomElement {
  connectedCallback() {
    if (super.connectedCallback) super.connectedCallback();

    if (!this.targets.button || !this.targets.tooltip) return;

    this.on('click', this.targets.button, () => {
      if (this.classList.contains(classes.open)) {
        this.close();
        return;
      }

      this.open();
    });
  }

  /**
   * Sets the tooltip position.
   */
  setPosition() {
    computePosition(this.targets.button, this.targets.tooltip, {
      placement: 'top',
      middleware: [
        shift(),
        offset({ mainAxis: 10, crossAxis: 10 }),
        size({
          padding: 10,
          apply({ availableWidth, availableHeight, elements }) {
            Object.assign(elements.floating.style, {
              maxWidth: `${Math.min(Math.max(0, availableWidth), 300)}px`,
              maxHeight: `${Math.max(0, availableHeight)}px`,
            });
          },
        }),
        ...(this.targets.arrow ? [arrow({ element: this.targets.arrow })] : []),
      ],
    }).then(({ x, y, middlewareData }) => {
      Object.assign(this.targets.tooltip.style, {
        left: `${x}px`,
        top: `${y}px`,
      });

      if (this.targets.arrow && middlewareData.arrow) {
        const { x: arrowX, y: arrowY } = middlewareData.arrow;

        Object.assign(this.targets.arrow.style, {
          left: arrowX != null ? `${arrowX}px` : '',
          top: arrowY != null ? `${arrowY}px` : '',
        });
      }
    });
  }

  /**
   * Opens the tooltip.
   */
  open() {
    this.setPosition();

    this.classList.add(classes.open);

    if (!this.removeDocumentClickEvent) {
      this.setDocumentClickEvent();
    }

    if (!this.removeAutoUpdate) {
      this.removeAutoUpdate = autoUpdate(this.targets.button, this.targets.tooltip, this.setPosition.bind(this));
    }
  }

  /**
   * Closes the tooltip.
   */
  close() {
    this.classList.remove(classes.open);

    if (this.removeDocumentClickEvent) {
      this.removeDocumentClickEvent = this.removeDocumentClickEvent();
    }

    if (this.removeAutoUpdate) {
      this.removeAutoUpdate = this.removeAutoUpdate();
    }
  }

  /**
   * Sets the document click event listener.
   */
  setDocumentClickEvent() {
    this.removeDocumentClickEvent = on('click', document, (event) => {
      if (!this.contains(event.target)) this.close();
    });
  }
}
